import { mediaData } from '@/mocks/home';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function MediaSection() {
  const ref = useScrollReveal();
  return (
    <section id="media" ref={ref} className="reveal-section py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            精选合集推荐
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            热门影视专题合集，一次收藏，尽情下载
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {mediaData.map((item, idx) => (
            <div
              key={idx}
              className="group relative rounded-lg overflow-hidden bg-foreground-950 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500/80 text-foreground-950 text-xs font-medium mb-2">
                  {item.tag}
                </span>
                <h3 className="font-heading text-lg md:text-xl font-bold text-white mb-1.5">
                  {item.title}
                </h3>
                <p className="text-white/65 text-sm leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}